<template>
  <div class="k-navbar__dropdown" v-click-outside="close">
    <button
      class="k-navbar__action-btn"
      :class="{ 'k-navbar__action-btn--active': isOpen }"
      @click="toggle"
      aria-label="Benachrichtigungen"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      <span v-if="count > 0" class="k-navbar__badge">
        {{ count }}
      </span>
    </button>
    <div v-if="isOpen" class="k-navbar__dropdown-menu k-navbar__dropdown-menu--right">
      <div class="k-navbar__dropdown-header">
        <span>Benachrichtigungen</span>
        <button class="k-navbar__dropdown-clear" @click="clearAll">
          Alle lesen
        </button>
      </div>
      <div class="k-navbar__dropdown-list">
        <div
          v-for="notification in notifications"
          :key="notification.id"
          class="k-navbar__notification"
        >
          <div class="k-navbar__notification-dot"></div>
          <div class="k-navbar__notification-content">
            <p class="k-navbar__notification-text">{{ notification.text }}</p>
            <span class="k-navbar__notification-time">{{ notification.time }}</span>
          </div>
        </div>
        <div v-if="notifications.length === 0" class="k-navbar__dropdown-empty">
          Keine neuen Benachrichtigungen
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * NavbarNotifications - Notifications dropdown component
 * @description Dropdown with notification list and clear functionality
 * @prop {Array} notifications - List of notification objects
 * @emits clear - When all notifications should be cleared
 */
export default {
  name: "NavbarNotifications",
  directives: {
    clickOutside: {
      bind(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    /**
     * Returns notification count
     * @returns {Number}
     */
    count() {
      return this.notifications.length;
    },
  },
  methods: {
    /**
     * Toggles dropdown visibility
     */
    toggle() {
      this.isOpen = !this.isOpen;
    },
    /**
     * Closes dropdown
     */
    close() {
      this.isOpen = false;
    },
    /**
     * Clears all notifications
     */
    clearAll() {
      this.$emit("clear");
      this.close();
    },
  },
};
</script>

